// hooks/useReturnParams.js
import { useCallback } from 'react';

const STORAGE_KEY = 'return_params';

export const useReturnParams = () => {
  const saveReturnParams = useCallback((url) => {
    sessionStorage.setItem(STORAGE_KEY, url);
  }, []);

  const getReturnParams = useCallback(() => {
    return sessionStorage.getItem(STORAGE_KEY);
  }, []);

  const clearReturnParams = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
  }, []);

  return { saveReturnParams, getReturnParams, clearReturnParams };
};
